import { twMerge } from "tailwind-merge";
import { CheckboxState, CHECKBOX_SIZE } from "./types";
import { SIZE_CLASS_MAP } from "./constants";

const useCheckboxStyles = (
  size: CHECKBOX_SIZE,
  selected: CheckboxState,
  disabled?: boolean,
  className?: string,
  checkboxClassName?: string
) => {
  const containerClassName = twMerge(
    "flex items-center w-full cursor-pointer",
    checkboxClassName
  );

  const inputClassName = twMerge(
    "rounded-md text-on-brand h-5 w-5 peer cursor-pointer appearance-none disabled:border-[#D4D5D8] border",
    SIZE_CLASS_MAP[size].inputClassName,
    selected !== "unChecked"
      ? "bg-fds-brand border-brand"
      : "bg-white border-[#A2A5AB]",
    disabled && "bg-[#E4E5E7]"
  );

  const labelClassName = twMerge(
    "pr-1.5 flex-1 text-wrap whitespace-nowrap text-ellipsis overflow-hidden cursor-pointer text-fds-primary disabled:text-disable text-right",
    SIZE_CLASS_MAP[size].labelClassName,
    disabled && "text-fds-disable",
    className
  );

  return {
    containerClassName,
    inputClassName,
    labelClassName,
  };
};

export default useCheckboxStyles;
